<svg-icon *ngIf="!disabled" src="{{imgUrl}}"></svg-icon>